import { makeStyles } from "@material-ui/core";

export const useTweetDeckTeamsStyles = makeStyles(() => ({
    title: {
        paddingBottom: 4
    },
    switch: {
        float: "right"
    }
}));
